exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".recommend-info[data-v-0b025977]{font-size:13px;color:#999;padding:0 20px 20px;line-height:20px}", ""]);

// exports
